import { makeAutoObservable } from 'mobx';
import performSilentLogin from './fn/performSilentLogin';

export default class AuthStore {
    isInitialized: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isInitialized = false;
    }

    setIsInitialized = (value: boolean): void => {
        this.isInitialized = value;
    };

    performSilentLogin = performSilentLogin;
}
